var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._b({},'div',_vm.$attrs,false),[_c('KDropdownButton',{attrs:{"items":_vm.computedItems,"disabled":_vm.disabled},on:{"click":_vm.exportHandler},model:{value:(_vm.selectedItem),callback:function ($$v) {_vm.selectedItem=$$v},expression:"selectedItem"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }